import { createStore } from "vuex";
import { auth } from "../modules/login/login-module";
import { home } from "../modules/home/home-module";
import { register } from "../modules/userRegister/userRegister-module";
import { notFound } from "@/modules/NotFound/not-found-module";
import createPersistedState from 'vuex-persistedstate';

/* It creates a store object with the modules, getters, state, mutations, and actions. */
const store = createStore({
  modules: {
    auth,
    home,
    register,
    notFound
  },
  getters: {},
  state: {},
  mutations: {},
  actions: {},
  plugins: [createPersistedState()],
});

export default store;
